const attachmentPathPattern = /^\/attachments\/([^/?#\\]+)\/?$/;

export const getAttachmentIdFromPath = (pathname) => {
    const match = typeof pathname === "string" && pathname.match(attachmentPathPattern);

    if (!match) return null;

    try {
        const id = decodeURIComponent(match[1]);
        const hasControlCharacter = Array.from(id).some(character => {
            const code = character.charCodeAt(0);
            return code < 32 || code === 127;
        });

        return id && id !== "." && id !== ".." && !/[\s/\\?#]/.test(id) && !hasControlCharacter
            ? id
            : null;
    } catch (_) {
        return null;
    }
};

export const getAttachmentLoginPath = (id) => {
    const path = `/attachments/${encodeURIComponent(id)}`;
    return `/login?redirect=${encodeURIComponent(path)}`;
};

export const getAttachmentLoginRedirect = (search) => {
    const redirect = new URLSearchParams(search).get("redirect");
    const id = getAttachmentIdFromPath(redirect);

    return id === null ? "/" : `/attachments/${encodeURIComponent(id)}`;
};

export const isAttachmentAuthenticationError = (error) => {
    if (!error) return false;

    if ((error.graphQLErrors || []).some(({ extensions }) =>
        extensions && extensions.category === "authentication"
    )) {
        return true;
    }

    const networkError = error.networkError || error;
    return Boolean(networkError && (
        networkError.statusCode === 401 ||
        networkError.status === 401 ||
        (networkError.response && networkError.response.status === 401)
    ));
};

export const redirectAttachmentToLogin = async (client, history, id) => {
    localStorage.removeItem("authToken");
    // Let Authentication unmount account views before clearing their cached data.
    client.writeData({ data: { authToken: false } });
    await Promise.resolve();

    try {
        // clearStore also cancels pending account queries without refetching them.
        await client.clearStore();
    } catch (_) {
        // Expired credentials must still reach login if cache cleanup rejects.
    } finally {
        client.writeData({
            data: {
                authToken: false,
                me: { __typename: "User", id: null, locale: "de" },
            },
        });
        history.replace(getAttachmentLoginPath(id));
    }
};
